import { Card, CardBody, Col, FormGroup, Input, Label, Row, TabPane } from "reactstrap";
import DefaultButton from "../../../../../components/Buttons/Default";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { post } from "../../../../../utils/helpers/api";

function LoginTab({ settings }) {
  const { t } = useTranslation();
  const [saveLoading, setSaveLoading] = useState(false);
  const [maxAttempts, setMaxAttempts] = useState('5');
  const [lockoutDur, setLockoutDur]   = useState('15');
  const [failAlert, setFailAlert]     = useState(true);
  const [newDeviceDetect, setNewDevice] = useState(true);

  useEffect(() => {
    setMaxAttempts(Number(settings?.security?.['login.max_failed_attempts']) || 5);
    setLockoutDur(Number(settings?.security?.['login.lockout_duration_minutes']) || 15);
    setFailAlert(Number(settings?.security?.['login.alert_on_failed_attempts']) === 1 ? true : false);
    setNewDevice(Number(settings?.security?.['login.new_device_detection']) === 1 ? true : false);
  }, [settings]);

  const saveSettings = async () => {
    setSaveLoading(true);

    const data = await post('/settings/security/login', {
      max_failed_attempts: maxAttempts,
      lockout_duration_minutes: lockoutDur,
      alert_on_failed_attempts: failAlert,
      new_device_detection: newDeviceDetect,
    });

    if(data?.success) {
      toast.success(t('security.settingsSaved'));
    }

    setSaveLoading(false);
  };

  return(
    <TabPane tabId="login-security">
      <Card className="mb-3">
        <CardBody>
          <p className="text-muted small fw-semibold text-uppercase mb-3">{t('security.bruteForce')}</p>
          <Row>
            <Col lg="4">
              <FormGroup>
                <Label>{t('security.maxFailedAttempts')}</Label>
                <Input type="select" value={maxAttempts} onChange={e => setMaxAttempts(e.target.value)}>
                  <option value="3">{t('security.attempts3')}</option>
                  <option value="5">{t('security.attempts5')}</option>
                  <option value="10">{t('security.attempts10')}</option>
                </Input>
              </FormGroup>
            </Col>
            <Col lg="4">
              <FormGroup>
                <Label>{t('security.lockoutDuration')}</Label>
                <Input type="select" value={lockoutDur} onChange={e => setLockoutDur(e.target.value)}>
                  <option value="5">{t('security.minutes5')}</option>
                  <option value="15">{t('security.minutes15')}</option>
                  <option value="30">{t('security.minutes30')}</option>
                  <option value="60">{t('security.hours1')}</option>
                </Input>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <Card className="mb-3">
        <CardBody>
          <p className="text-muted small fw-semibold text-uppercase mb-3">{t('security.loginAlerts')}</p>
          {[
            { label: t('security.alertFailedAttempts'), desc: t('security.alertFailedAttemptsDesc'), val: failAlert,      set: setFailAlert      },
            { label: t('security.newDeviceDetect'),     desc: t('security.newDeviceDetectDesc'),     val: newDeviceDetect, set: setNewDevice     },
          ].map((item, i, arr) => (
            <div key={i} className={`d-flex justify-content-between align-items-center py-3 ${i < arr.length - 1 ? 'border-bottom' : ''}`}>
              <div>
                <p className="mb-0 fw-medium">{item.label}</p>
                <small className="text-muted">{item.desc}</small>
              </div>
              <div className="form-check form-switch mb-0">
                <input className="form-check-input" type="checkbox" role="switch" checked={item.val} onChange={() => item.set(!item.val)} />
              </div>
            </div>
          ))}
        </CardBody>
      </Card>
      <DefaultButton color="primary" size="sm" onClick={saveSettings} disabled={saveLoading}>
        {saveLoading ? t('common.saving') : t('common.save')}
      </DefaultButton>
    </TabPane>
  );
}

export default LoginTab;